export default function siblingElements(el) {
    return [...el.parentElement.children].filter(c => c !== el)
}